import { render } from "./App.vue?vue&type=template&id=52bb626b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=52bb626b&lang=scss"

import exportComponent from "/Users/mithun-cc/Desktop/Websites/bpcone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__